import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as userApi from '@services/api/userProfile'

export const changePassword = createAsyncThunk(
  'userProfile/changePassword',
  async (data: any) => {
    const response = userApi.changePassword(data)
    return response
  }
)

const initialState = {
  showChangePassword: false
}

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    toggleChangePasswordPopup: state => {
      state.showChangePassword = !state.showChangePassword
    }
  },
  extraReducers: builder => {
    builder.addCase(changePassword.fulfilled, () => {
    })
  }
})

export const {
  toggleChangePasswordPopup
} = userProfileSlice.actions

export const userProfileReducer = userProfileSlice.reducer

export default userProfileSlice.reducer
